import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function DrillingRigIcon(props) {
  const { height, width, iconColor } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 17.74" height={height} width={width}>
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={iconColor}
          d="M19.76,16.25,19,13.15l-.66,0-.19-5.79,1.24.23.3-1.09-13.87-3L4.7.09A.14.14,0,0,0,4.61,0a.13.13,0,0,0-.12,0C3,1.72,2.07,2.85,1.63,4.75A10.6,10.6,0,0,0,1.7,9.94v6.31H0v1.49H20.93V16.25ZM11,9.79l.36,1.38-1.08,1.34-1-1.25.38-1.49ZM2.37,16.25V10.31L5.55,5.17l4,.73s0,1.42,0,1.42l-.47.18L6.83,16.25ZM9,12.56l.63.79-1.2,1.48Zm-.27,3.69,1.61-2,1.63,2ZM11,13.35l.71-.89.69,2.62Zm5.8-.2-1.07,3.1H13.83L11.55,7.5l-.41-.16,0-1.18,6.09,1.06.05,5.94Z"
          id="Layer_1-2"
          data-name="Layer 1"
        />
      </g>
    </svg>
  );
}

DrillingRigIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

DrillingRigIcon.defaultProps = {
  width: 22,
  height: undefined,
  iconColor: colors.colorGrey06
};

export default DrillingRigIcon;
